$(() => {
  attachDatepicker();
});

function attachDatepicker() {
  $('[type="date"]').each((_, el) => {
    if (el.type != 'date') {
      $(el).datepicker({
        defaultDate: $(el).value,
        dateFormat: 'yy-mm-dd',
        onSelect: function() {
          $(el).change();
        }
      });
    }
  });
}
